import Bullet from '@/assets/graphical-elements/bullet.svg'
import {cn} from '@/lib/utils'
import {type IconProps} from '../types'

export const BulletIcon = ({className}: IconProps) => <Bullet className={cn('fill-current', className)} />
